export const MenuList = [
	// Dashboard
	{
		title: "Dashboard",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
					fill="white"
				/>
				<path
					d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
					fill="white"
				/>
				<path
					d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
					fill="white"
				/>
				<path
					d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
					fill="white"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
					fill="#7B7B7B"
				/>
				<path
					d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z"
					fill="#7B7B7B"
				/>
				<path
					d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
					fill="#7B7B7B"
				/>
				<path
					d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		to: "",
		text: "dashboard",
		permission: "dashboard",
	},

	// Staff Managment
	{
		title: "Staff Managment",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M18 2H6C4.34 2 3 3.33 3 4.97V15.88C3 17.52 4.34 18.85 6 18.85H6.76C7.56 18.85 8.32 19.16 8.88 19.72L10.59 21.41C11.37 22.18 12.64 22.18 13.42 21.41L15.13 19.72C15.69 19.16 16.46 18.85 17.25 18.85H18C19.66 18.85 21 17.52 21 15.88V4.97C21 3.33 19.66 2 18 2ZM12 5.75C13.29 5.75 14.33 6.79 14.33 8.08C14.33 9.37 13.29 10.41 12 10.41C10.71 10.41 9.67 9.36 9.67 8.08C9.67 6.79 10.71 5.75 12 5.75ZM14.68 15.06H9.32C8.51 15.06 8.04 14.16 8.49 13.49C9.17 12.48 10.49 11.8 12 11.8C13.51 11.8 14.83 12.48 15.51 13.49C15.96 14.16 15.48 15.06 14.68 15.06Z"
					fill="white"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z"
					fill="#7B7B7B"
				/>
				<path
					d="M20.79 14.7C19.67 15.45 18.1 15.73 16.65 15.54C17.03 14.72 17.23 13.81 17.24 12.85C17.24 11.85 17.02 10.9 16.6 10.07C18.08 9.87004 19.65 10.15 20.78 10.9C22.36 11.94 22.36 13.65 20.79 14.7Z"
					fill="#7B7B7B"
				/>
				<path
					d="M6.44 7.77C6.51 7.76 6.58 7.76 6.65 7.77C8.2 7.72 9.43 6.45 9.43 4.89C9.43 3.29 8.14 2 6.54 2C4.95 2 3.66 3.29 3.66 4.89C3.66 6.45 4.89 7.72 6.44 7.77Z"
					fill="#7B7B7B"
				/>
				<path
					d="M6.55 12.85C6.55 13.82 6.75999 14.74 7.14 15.57C5.73 15.72 4.26 15.42 3.18 14.71C1.6 13.66 1.6 11.95 3.18 10.9C4.25 10.18 5.75999 9.88998 7.18 10.05C6.77 10.89 6.55 11.84 6.55 12.85Z"
					fill="#7B7B7B"
				/>
				<path
					d="M12.12 15.87C12.04 15.86 11.95 15.86 11.86 15.87C10.02 15.81 8.55 14.3 8.55 12.44C8.56 10.54 10.09 9 12 9C13.9 9 15.44 10.54 15.44 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z"
					fill="#7B7B7B"
				/>
				<path
					d="M8.87 17.94C7.36 18.95 7.36 20.61 8.87 21.61C10.59 22.76 13.41 22.76 15.13 21.61C16.64 20.6 16.64 18.94 15.13 17.94C13.42 16.79 10.6 16.79 8.87 17.94Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		text: "staff_managment",
		permission: "staff",
		content: [
			// Admins
			{
				title: "Admins",
				to: "/admins",
				text: "admins",
				permission: "admin",
			},
			// Roles
			{
				title: "Roles",
				to: "/roles",
				text: "roles",
				permission: "rules",
			},
		],
	},

	// Zones Managment
	{
		title: "Zones Managment",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M17 2.43005H7C4 2.43005 2 4.43005 2 7.43005V13.4301C2 16.4301 4 18.4301 7 18.4301V20.5601C7 21.3601 7.89 21.8401 8.55 21.3901L13 18.4301H17C20 18.4301 22 16.4301 22 13.4301V7.43005C22 4.43005 20 2.43005 17 2.43005ZM12 14.6001C11.58 14.6001 11.25 14.2601 11.25 13.8501C11.25 13.4401 11.58 13.1001 12 13.1001C12.42 13.1001 12.75 13.4401 12.75 13.8501C12.75 14.2601 12.42 14.6001 12 14.6001ZM13.26 10.4501C12.87 10.7101 12.75 10.8801 12.75 11.1601V11.3701C12.75 11.7801 12.41 12.1201 12 12.1201C11.59 12.1201 11.25 11.7801 11.25 11.3701V11.1601C11.25 10.0001 12.1 9.43005 12.42 9.21005C12.79 8.96005 12.91 8.79005 12.91 8.53005C12.91 8.03005 12.5 7.62005 12 7.62005C11.5 7.62005 11.09 8.03005 11.09 8.53005C11.09 8.94005 10.75 9.28005 10.34 9.28005C9.93 9.28005 9.59 8.94005 9.59 8.53005C9.59 7.20005 10.67 6.12005 12 6.12005C13.33 6.12005 14.41 7.20005 14.41 8.53005C14.41 9.67005 13.57 10.2401 13.26 10.4501Z"
					fill="white"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M17 2.42993H7C4 2.42993 2 4.42993 2 7.42993V13.4299C2 16.4299 4 18.4299 7 18.4299V20.5599C7 21.3599 7.89 21.8399 8.55 21.3899L13 18.4299H17C20 18.4299 22 16.4299 22 13.4299V7.42993C22 4.42993 20 2.42993 17 2.42993ZM12 14.5999C11.58 14.5999 11.25 14.2599 11.25 13.8499C11.25 13.4399 11.58 13.0999 12 13.0999C12.42 13.0999 12.75 13.4399 12.75 13.8499C12.75 14.2599 12.42 14.5999 12 14.5999ZM13.26 10.4499C12.87 10.7099 12.75 10.8799 12.75 11.1599V11.3699C12.75 11.7799 12.41 12.1199 12 12.1199C11.59 12.1199 11.25 11.7799 11.25 11.3699V11.1599C11.25 9.99993 12.1 9.42993 12.42 9.20993C12.79 8.95993 12.91 8.78993 12.91 8.52993C12.91 8.02993 12.5 7.61993 12 7.61993C11.5 7.61993 11.09 8.02993 11.09 8.52993C11.09 8.93993 10.75 9.27993 10.34 9.27993C9.93 9.27993 9.59 8.93993 9.59 8.52993C9.59 7.19993 10.67 6.11993 12 6.11993C13.33 6.11993 14.41 7.19993 14.41 8.52993C14.41 9.66993 13.57 10.2399 13.26 10.4499Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		to: "zones",
		text: "zones_managment",
		permission: "zone",
	},

	// Parking
	{
		title: "Parking",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_145_2904)">
					<path
						d="M17.0195 10.3969C16.9423 10.3969 16.863 10.408 16.7838 10.4297L15.888 10.6765L14.9579 8.41057C14.6943 7.76866 13.9154 7.24634 13.2215 7.24634H4.51619C3.82223 7.24634 3.04337 7.76866 2.77988 8.41057L1.85096 10.6733L0.966249 10.4297C0.887077 10.4079 0.807818 10.3968 0.730584 10.3968C0.307163 10.3968 -9.91821e-05 10.7203 -9.91821e-05 11.1658V11.6938C-9.91821e-05 12.214 0.423146 12.6372 0.943263 12.6372H1.04463L0.894475 13.0029C0.649651 13.5992 0.450358 14.6089 0.450358 15.2537V19.7552C0.450358 20.2753 0.873603 20.6986 1.39372 20.6986H2.62576C3.14588 20.6986 3.56913 20.2753 3.56913 19.7552V18.6312H14.1685V19.7552C14.1685 20.2753 14.5917 20.6986 15.1118 20.6986H16.3437C16.8638 20.6986 17.2871 20.2753 17.2871 19.7552V15.2538C17.2871 14.6091 17.0878 13.5993 16.843 13.003L16.6928 12.6373H16.8068C17.3269 12.6373 17.7501 12.2141 17.7501 11.6939V11.1659C17.7502 10.7204 17.4429 10.3969 17.0195 10.3969ZM2.52722 12.1249L3.93434 8.69758C4.09197 8.31361 4.56048 7.99939 4.97554 7.99939H12.7622C13.1772 7.99939 13.6457 8.31352 13.8034 8.69758L15.2105 12.1249C15.368 12.5089 15.1575 12.8231 14.7424 12.8231H2.99538C2.58023 12.823 2.36967 12.5089 2.52722 12.1249ZM5.66827 16.4602C5.66827 16.6677 5.49839 16.8374 5.29099 16.8374H2.61801C2.41044 16.8374 2.24065 16.6676 2.24065 16.4602V15.1774C2.24065 14.9699 2.41044 14.8001 2.61801 14.8001H5.29099C5.49839 14.8001 5.66827 14.9699 5.66827 15.1774V16.4602ZM15.4717 16.4602C15.4717 16.6677 15.3018 16.8374 15.0944 16.8374H12.4214C12.214 16.8374 12.0442 16.6676 12.0442 16.4602V15.1774C12.0442 14.9699 12.214 14.8001 12.4214 14.8001H15.0944C15.3018 14.8001 15.4717 14.9699 15.4717 15.1774V16.4602Z"
						fill="white"
					/>
					<path
						d="M22.82 3.30127H18.352C17.7013 3.30127 17.1721 3.83063 17.1721 4.48118V8.94929C17.1721 9.59992 17.7014 10.1293 18.352 10.1293H20.1456V20.1575C20.1456 20.4008 20.3427 20.5979 20.5859 20.5979C20.8292 20.5979 21.0263 20.4008 21.0263 20.1575V10.1294H22.82C23.4706 10.1294 23.9999 9.60001 23.9999 8.94938V4.48127C23.9999 3.83063 23.4706 3.30127 22.82 3.30127ZM21.808 7.00594C21.5511 7.23729 21.1725 7.35459 20.6831 7.35459H20.0361C19.9584 7.35459 19.8951 7.41791 19.8951 7.49559V8.58664C19.8951 8.70517 19.7987 8.80152 19.6802 8.80152H19.1902C19.0716 8.80152 18.9752 8.70508 18.9752 8.58664V4.84427C18.9752 4.72565 19.0716 4.62922 19.1902 4.62922H20.4245C21.2422 4.62922 21.5474 4.75242 21.7983 4.96528C22.0628 5.18976 22.1968 5.53357 22.1968 5.98737C22.1967 6.43078 22.0661 6.77336 21.808 7.00594Z"
						fill="white"
					/>
					<path
						d="M21.1076 5.5327C20.9882 5.44252 20.7769 5.39673 20.4798 5.39673H20.036C19.9583 5.39673 19.8951 5.45996 19.8951 5.53755V6.43423C19.8951 6.51182 19.9583 6.57505 20.036 6.57505H20.3019C20.3995 6.57505 20.5573 6.56783 20.6536 6.55893C20.747 6.55039 21.0108 6.51217 21.1076 6.43908C21.2237 6.35119 21.2827 6.19919 21.2827 5.98739C21.2827 5.77356 21.2237 5.62059 21.1076 5.5327Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_145_2904">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_145_2750)">
					<path
						d="M17.0195 10.3971C16.9423 10.3971 16.863 10.4082 16.7838 10.43L15.888 10.6768L14.9579 8.41081C14.6943 7.7689 13.9154 7.24658 13.2215 7.24658H4.5162C3.82224 7.24658 3.04338 7.7689 2.77989 8.41081L1.85097 10.6736L0.966256 10.4299C0.887085 10.4082 0.807826 10.3971 0.730592 10.3971C0.307171 10.3971 -9.15527e-05 10.7205 -9.15527e-05 11.166V11.6941C-9.15527e-05 12.2142 0.423153 12.6375 0.943271 12.6375H1.04463L0.894482 13.0032C0.649659 13.5994 0.450366 14.6092 0.450366 15.254V19.7555C0.450366 20.2756 0.873611 20.6988 1.39373 20.6988H2.62577C3.14589 20.6988 3.56913 20.2756 3.56913 19.7555V18.6314H14.1685V19.7555C14.1685 20.2756 14.5917 20.6988 15.1119 20.6988H16.3437C16.8638 20.6988 17.2871 20.2756 17.2871 19.7555V15.2541C17.2871 14.6093 17.0878 13.5996 16.843 13.0033L16.6928 12.6375H16.8068C17.3269 12.6375 17.7501 12.2143 17.7501 11.6942V11.1661C17.7502 10.7206 17.4429 10.3971 17.0195 10.3971ZM2.52723 12.1252L3.93434 8.69782C4.09198 8.31385 4.56049 7.99963 4.97555 7.99963H12.7622C13.1772 7.99963 13.6457 8.31377 13.8034 8.69782L15.2105 12.1252C15.368 12.5091 15.1575 12.8234 14.7424 12.8234H2.99538C2.58024 12.8233 2.36968 12.5091 2.52723 12.1252ZM5.66827 16.4604C5.66827 16.668 5.49839 16.8377 5.291 16.8377H2.61802C2.41045 16.8377 2.24066 16.6679 2.24066 16.4604V15.1776C2.24066 14.9701 2.41045 14.8004 2.61802 14.8004H5.291C5.49839 14.8004 5.66827 14.9701 5.66827 15.1776V16.4604ZM15.4717 16.4604C15.4717 16.668 15.3018 16.8377 15.0944 16.8377H12.4214C12.214 16.8377 12.0442 16.6679 12.0442 16.4604V15.1776C12.0442 14.9701 12.214 14.8004 12.4214 14.8004H15.0944C15.3018 14.8004 15.4717 14.9701 15.4717 15.1776V16.4604Z"
						fill="#7B7B7B"
					/>
					<path
						d="M22.82 3.30127H18.352C17.7013 3.30127 17.1721 3.83063 17.1721 4.48118V8.94929C17.1721 9.59992 17.7014 10.1293 18.352 10.1293H20.1456V20.1575C20.1456 20.4008 20.3427 20.5979 20.5859 20.5979C20.8292 20.5979 21.0263 20.4008 21.0263 20.1575V10.1294H22.82C23.4706 10.1294 23.9999 9.60001 23.9999 8.94938V4.48127C23.9999 3.83063 23.4706 3.30127 22.82 3.30127ZM21.808 7.00594C21.5511 7.23729 21.1725 7.35459 20.6831 7.35459H20.0361C19.9584 7.35459 19.8951 7.41791 19.8951 7.49559V8.58664C19.8951 8.70517 19.7987 8.80152 19.6802 8.80152H19.1902C19.0716 8.80152 18.9752 8.70508 18.9752 8.58664V4.84427C18.9752 4.72565 19.0716 4.62922 19.1902 4.62922H20.4245C21.2422 4.62922 21.5474 4.75242 21.7983 4.96528C22.0628 5.18976 22.1968 5.53357 22.1968 5.98737C22.1967 6.43078 22.0661 6.77336 21.808 7.00594Z"
						fill="#7B7B7B"
					/>
					<path
						d="M21.1076 5.53295C20.9882 5.44277 20.7769 5.39697 20.4798 5.39697H20.036C19.9583 5.39697 19.8951 5.4602 19.8951 5.53779V6.43448C19.8951 6.51206 19.9583 6.5753 20.036 6.5753H20.3019C20.3995 6.5753 20.5573 6.56807 20.6536 6.55918C20.747 6.55064 21.0108 6.51242 21.1076 6.43932C21.2237 6.35143 21.2826 6.19943 21.2826 5.98763C21.2826 5.77381 21.2237 5.62084 21.1076 5.53295Z"
						fill="#7B7B7B"
					/>
				</g>
				<defs>
					<clipPath id="clip0_145_2750">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		),
		text: "parking",
		permission: "parking_module",
		content: [
			// Parking slots
			{
				title: "Parking slots",
				to: "/parking-slots",
				text: "parking_slots",
				permission: "parking_slot",
			},
			// Parking
			{
				title: "Parking",
				to: "/parking",
				text: "parking",
				permission: "parking",
			},
			// Quick Valet
			{
				title: "Quick Valet",
				to: "/quick-valet",
				text: "quick_valet",
				permission: "quick_valet",
			},
			// QR Code Grouping
			{
				title: "QR Code Grouping",
				to: "/qr-code-grouping",
				text: "qr_code_grouping",
				permission: "qr_code_grouping",
			},
			// QR Code Valet
			{
				title: "QR Code Valet",
				to: "/qr-code-valet",
				text: "qr_code_valet",
				permission: "qr_code_valet",
			},
			// QR Parking
			{
				title: "QR Parking",
				to: "/qr-parking",
				text: "qr_parking",
				permission: "qr_parking",
			},
		],
	},

	// Drivers Managment
	{
		title: "Drivers Managment",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_145_2766)">
					<path
						d="M20.0793 18.5872L16.0926 12.4633C15.8042 12.0197 15.3122 11.8205 14.8192 11.8205C14.7172 11.8205 14.506 11.8229 14.2777 11.8261C14.2599 11.7962 14.2413 11.7666 14.2113 11.7464L13.2071 11.0795C13.0913 11.0027 12.9409 11.0067 12.8298 11.0885L11.9993 11.7014L11.1683 11.0885C11.0563 11.0067 10.9068 11.0027 10.79 11.0795L9.7877 11.7464C9.75938 11.7649 9.74139 11.7908 9.72488 11.818C9.4883 11.8195 9.26785 11.8208 9.17499 11.8208C8.68419 11.8208 8.19443 12.0226 7.90787 12.4633L3.92114 18.5872C3.49728 19.2373 3.66883 20.1067 4.30805 20.5469L5.19301 21.1569C5.72649 19.8865 6.60758 18.8002 7.71412 18.0072L7.94232 17.6562V17.8454C8.74417 17.3157 9.65446 16.94 10.6317 16.7559C10.3414 16.1115 10.0977 15.3438 9.91897 14.6202C9.71077 13.7758 9.58866 12.9933 9.58866 12.5501C9.58866 12.3859 9.60987 12.2277 9.64207 12.0735L10.3673 14.4733C10.4048 14.599 10.5135 14.6897 10.6437 14.7051C10.6568 14.7065 10.6696 14.7073 10.6821 14.7073C10.798 14.7073 10.9076 14.6461 10.9672 14.5437L11.5326 13.5699L11.6916 13.7284C11.311 14.2319 11.1614 15.6492 11.1034 16.6838C11.3971 16.6479 11.6946 16.624 11.9978 16.624C12.3017 16.624 12.6002 16.6483 12.8948 16.6842C12.8366 15.6496 12.6871 14.2324 12.3056 13.7284L12.4646 13.5689L13.0318 14.5436C13.0914 14.646 13.1994 14.7073 13.3162 14.7073C13.3287 14.7073 13.3418 14.7065 13.3544 14.705C13.4845 14.6896 13.5932 14.5989 13.6317 14.4733L14.3565 12.0785C14.3875 12.2312 14.408 12.3878 14.408 12.5501C14.408 13.3736 13.9951 15.3599 13.3654 16.7559C14.3445 16.9405 15.2563 17.3171 16.0582 17.8482V17.6571L16.2902 18.0127C17.3929 18.8061 18.2716 19.8906 18.8036 21.1588L19.6924 20.5469C20.3315 20.1067 20.5022 19.2373 20.0793 18.5872ZM10.7784 13.5577L10.3563 12.1597L10.9633 11.7559L11.5671 12.2012L10.7784 13.5577ZM13.2196 13.5577L12.4317 12.2012L13.035 11.7558L13.6426 12.1596L13.2196 13.5577Z"
						fill="white"
					/>
					<path
						d="M9.93329 20.8118L10.6538 21.76C11.0533 21.5192 11.5162 21.3872 11.9978 21.3872C12.4804 21.3872 12.9442 21.5191 13.3436 21.7603L14.0641 20.8115C13.5023 20.2824 12.7731 19.9922 11.9987 19.9922C11.2239 19.9922 10.4939 20.2828 9.93329 20.8118Z"
						fill="white"
					/>
					<path
						d="M8.65813 7.86816C8.68258 9.11554 9.39118 10.1843 10.4236 10.7392C10.8951 10.993 11.4268 11.15 12.0002 11.15C12.5727 11.15 13.1029 10.9933 13.5738 10.74C14.6059 10.1857 15.3172 9.1172 15.3408 7.86939C14.4892 8.46108 13.2878 8.84564 12.0002 8.84564C10.7125 8.84564 9.51089 8.46108 8.65813 7.86816Z"
						fill="white"
					/>
					<path
						d="M8.56247 4.90658L8.55145 5.89664C8.55326 6.68022 10.0962 7.70086 12.0001 7.70086C13.9041 7.70086 15.4456 6.68022 15.4464 5.89664L15.4363 4.90707C15.9373 4.77663 16.3261 4.58283 16.575 4.30431C16.7701 4.08703 16.8821 3.8191 16.8821 3.48192C16.8822 1.95431 14.6944 0 12.0002 0C9.30361 0 7.11816 1.95431 7.11816 3.48192C7.11816 3.8191 7.22954 4.08659 7.42373 4.30431C7.67281 4.58278 8.06207 4.77658 8.56247 4.90658Z"
						fill="white"
					/>
					<path
						d="M11.9978 17.4897C8.40822 17.4897 5.48761 20.4105 5.48761 24H7.12768C7.12768 23.9977 7.12768 23.9944 7.12768 23.9921V23.9906C7.18099 23.6693 7.45652 23.4352 7.78003 23.4352C7.78566 23.4352 7.79194 23.4357 7.79816 23.4357L10.3319 23.5014C10.2842 23.6606 10.2511 23.8258 10.2511 24.0001H13.746C13.746 23.8258 13.7132 23.6606 13.6646 23.5014L16.1992 23.4357C16.2045 23.4357 16.2099 23.4352 16.2164 23.4352C16.5396 23.4352 16.8164 23.6693 16.8693 23.9906V23.9921C16.8693 23.9944 16.8693 23.9977 16.8693 24H18.5079C18.508 20.4105 15.5883 17.4897 11.9978 17.4897ZM14.8082 21.2621L13.4576 23.0417C13.1445 22.567 12.6086 22.2526 11.9977 22.2526C11.3883 22.2526 10.8519 22.5667 10.5394 23.0414L9.18915 21.2626C8.9589 20.9591 8.98776 20.5314 9.25736 20.2618C10.0145 19.5051 11.0062 19.1267 11.9986 19.1267C12.9909 19.1267 13.9824 19.5051 14.7408 20.2625C15.0101 20.5318 15.0385 20.9587 14.8082 21.2621Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_145_2766">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_145_2925)">
					<path
						d="M20.0793 18.5875L16.0926 12.4636C15.8042 12.0199 15.3122 11.8207 14.8192 11.8207C14.7172 11.8207 14.506 11.8232 14.2777 11.8264C14.2599 11.7965 14.2413 11.7668 14.2113 11.7466L13.2071 11.0798C13.0913 11.0029 12.9409 11.007 12.8298 11.0887L11.9993 11.7016L11.1683 11.0887C11.0563 11.007 10.9068 11.0029 10.79 11.0798L9.7877 11.7466C9.75938 11.7651 9.74139 11.7911 9.72488 11.8182C9.4883 11.8197 9.26785 11.821 9.17499 11.821C8.68419 11.821 8.19443 12.0229 7.90787 12.4636L3.92114 18.5875C3.49728 19.2376 3.66883 20.1069 4.30805 20.5471L5.19301 21.1571C5.72649 19.8867 6.60758 18.8005 7.71412 18.0074L7.94232 17.6565V17.8457C8.74417 17.3159 9.65446 16.9403 10.6317 16.7562C10.3414 16.1117 10.0977 15.344 9.91897 14.6204C9.71077 13.776 9.58866 12.9935 9.58866 12.5504C9.58866 12.3861 9.60987 12.228 9.64207 12.0737L10.3673 14.4735C10.4048 14.5992 10.5135 14.69 10.6437 14.7053C10.6568 14.7068 10.6696 14.7076 10.6821 14.7076C10.798 14.7076 10.9076 14.6463 10.9672 14.5439L11.5326 13.5701L11.6916 13.7286C11.311 14.2322 11.1614 15.6494 11.1034 16.6841C11.3971 16.6481 11.6946 16.6242 11.9978 16.6242C12.3017 16.6242 12.6002 16.6486 12.8948 16.6845C12.8366 15.6499 12.6871 14.2326 12.3056 13.7286L12.4646 13.5691L13.0318 14.5439C13.0914 14.6463 13.1994 14.7075 13.3162 14.7075C13.3287 14.7075 13.3418 14.7067 13.3544 14.7053C13.4845 14.6899 13.5932 14.5991 13.6317 14.4735L14.3565 12.0787C14.3875 12.2314 14.408 12.3881 14.408 12.5503C14.408 13.3738 13.9951 15.3601 13.3654 16.7561C14.3445 16.9408 15.2563 17.3173 16.0582 17.8484V17.6573L16.2902 18.0129C17.3929 18.8064 18.2716 19.8908 18.8036 21.1591L19.6924 20.5471C20.3315 20.1069 20.5022 19.2376 20.0793 18.5875ZM10.7784 13.5579L10.3563 12.1599L10.9633 11.7561L11.5671 12.2015L10.7784 13.5579ZM13.2196 13.5579L12.4317 12.2014L13.035 11.7561L13.6426 12.1599L13.2196 13.5579Z"
						fill="#7B7B7B"
					/>
					<path
						d="M9.93329 20.8118L10.6538 21.76C11.0533 21.5192 11.5162 21.3872 11.9978 21.3872C12.4804 21.3872 12.9442 21.5191 13.3436 21.7603L14.0641 20.8115C13.5023 20.2824 12.7731 19.9922 11.9987 19.9922C11.2239 19.9922 10.4939 20.2828 9.93329 20.8118Z"
						fill="#7B7B7B"
					/>
					<path
						d="M8.65813 7.86841C8.68258 9.11578 9.39118 10.1845 10.4236 10.7394C10.8951 10.9933 11.4268 11.1503 12.0002 11.1503C12.5727 11.1503 13.1029 10.9936 13.5738 10.7402C14.6059 10.186 15.3172 9.11745 15.3408 7.86963C14.4892 8.46132 13.2878 8.84588 12.0002 8.84588C10.7125 8.84588 9.51089 8.46132 8.65813 7.86841Z"
						fill="#7B7B7B"
					/>
					<path
						d="M8.56248 4.90658L8.55145 5.89664C8.55327 6.68022 10.0962 7.70086 12.0002 7.70086C13.9041 7.70086 15.4456 6.68022 15.4464 5.89664L15.4363 4.90707C15.9373 4.77663 16.3261 4.58283 16.575 4.30431C16.7701 4.08703 16.8821 3.8191 16.8821 3.48192C16.8822 1.95431 14.6944 0 12.0002 0C9.30362 0 7.11817 1.95431 7.11817 3.48192C7.11817 3.8191 7.22955 4.08659 7.42374 4.30431C7.67281 4.58278 8.06208 4.77658 8.56248 4.90658Z"
						fill="#7B7B7B"
					/>
					<path
						d="M11.9978 17.4897C8.40822 17.4897 5.48761 20.4105 5.48761 24H7.12768C7.12768 23.9977 7.12768 23.9944 7.12768 23.9921V23.9906C7.18099 23.6693 7.45652 23.4352 7.78003 23.4352C7.78566 23.4352 7.79194 23.4357 7.79816 23.4357L10.3319 23.5014C10.2842 23.6606 10.2511 23.8258 10.2511 24.0001H13.746C13.746 23.8258 13.7132 23.6606 13.6646 23.5014L16.1992 23.4357C16.2045 23.4357 16.2099 23.4352 16.2164 23.4352C16.5396 23.4352 16.8164 23.6693 16.8693 23.9906V23.9921C16.8693 23.9944 16.8693 23.9977 16.8693 24H18.5079C18.508 20.4105 15.5883 17.4897 11.9978 17.4897ZM14.8082 21.2621L13.4576 23.0417C13.1445 22.567 12.6086 22.2526 11.9977 22.2526C11.3883 22.2526 10.8519 22.5667 10.5394 23.0414L9.18915 21.2626C8.9589 20.9591 8.98776 20.5314 9.25736 20.2618C10.0145 19.5051 11.0062 19.1267 11.9986 19.1267C12.9909 19.1267 13.9824 19.5051 14.7408 20.2625C15.0101 20.5318 15.0385 20.9587 14.8082 21.2621Z"
						fill="#7B7B7B"
					/>
				</g>
				<defs>
					<clipPath id="clip0_145_2925">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		),
		text: "drivers_managment",
		permission: "drivers_managment",
		content: [
			// Drivers
			{
				title: "Drivers",
				to: "/drivers",
				text: "drivers",
				permission: "driver",
			},
			// Requests
			{
				title: "Requests",
				to: "/requests",
				text: "requests",
				permission: "request",
			},
		],
	},

	// Users
	{
		title: "Users",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M8.36909 6.30925C8.2919 6.27599 8.22615 6.22085 8.17994 6.15064C8.13374 6.08043 8.10911 5.99823 8.1091 5.91418C8.10858 5.85411 8.12039 5.79457 8.14382 5.73925C8.16725 5.68393 8.20179 5.63401 8.2453 5.59258C8.27185 5.56727 8.29731 5.5423 8.31636 5.52227C8.45101 5.38047 8.56981 5.22443 8.67066 5.0569C8.93598 4.61418 9.06752 4.10415 9.0494 3.58834C9.03128 3.07253 8.86428 2.57299 8.56855 2.14998C8.27282 1.72698 7.861 1.39859 7.38278 1.20445C6.90455 1.01031 6.38036 0.958708 5.87347 1.05587C5.35688 1.14631 4.87947 1.39011 4.50332 1.75554C4.12716 2.12098 3.86968 2.59115 3.76435 3.10491C3.66699 3.54724 3.68358 4.00705 3.81255 4.44121C3.94152 4.87538 4.17866 5.26967 4.50171 5.58711C4.54557 5.62867 4.58067 5.67857 4.60498 5.73387C4.62929 5.78918 4.64231 5.84879 4.64328 5.9092V5.91137C4.64402 5.99612 4.61974 6.07921 4.57347 6.15022C4.5272 6.22123 4.46101 6.27701 4.38318 6.31056C3.31769 6.7519 2.46801 7.59384 2.01693 8.65525C1.6999 9.38214 1.54088 10.1681 1.55039 10.961V11.5327C1.5504 11.7801 1.64869 12.0174 1.82363 12.1923C1.99857 12.3673 2.23584 12.4655 2.48324 12.4655H10.2708C10.5181 12.4655 10.7554 12.3672 10.9303 12.1923C11.1053 12.0174 11.2036 11.7801 11.2036 11.5327V10.9556C11.2131 10.1629 11.0538 9.37718 10.7362 8.65078C10.2844 7.59028 9.43445 6.74948 8.36909 6.30925Z"
					fill="#FFFFFF"
				/>
				<path
					d="M22.2971 18.2182C21.8453 17.1577 20.9954 16.317 19.9301 15.8767C19.8529 15.8434 19.7872 15.7883 19.7409 15.718C19.6947 15.6478 19.6701 15.5656 19.6701 15.4815C19.6696 15.4215 19.6814 15.3619 19.7048 15.3066C19.7282 15.2513 19.7628 15.2014 19.8062 15.16C19.8329 15.1346 19.8583 15.1097 19.8775 15.0896C20.0122 14.9479 20.131 14.7918 20.2319 14.6242C20.4972 14.1815 20.6288 13.6715 20.6107 13.1557C20.5926 12.6399 20.4256 12.1403 20.1298 11.7173C19.8341 11.2943 19.4222 10.9659 18.944 10.7718C18.4658 10.5777 17.9416 10.5261 17.4347 10.6233C16.9181 10.7137 16.4407 10.9575 16.0646 11.3229C15.6885 11.6883 15.431 12.1584 15.3256 12.6721C15.2282 13.1145 15.2448 13.5743 15.3738 14.0085C15.5028 14.4427 15.7399 14.837 16.063 15.1544C16.1068 15.196 16.1419 15.2458 16.1662 15.3011C16.1905 15.3564 16.2035 15.416 16.2044 15.4764V15.4787C16.2052 15.5634 16.1809 15.6465 16.1347 15.7175C16.0884 15.7885 16.0222 15.8443 15.9444 15.8778C14.8789 16.3192 14.0292 17.1611 13.5781 18.2225C13.2611 18.9494 13.102 19.7354 13.1115 20.5284V21.1C13.1115 21.2225 13.1356 21.3438 13.1825 21.457C13.2294 21.5702 13.2981 21.673 13.3847 21.7596C13.4714 21.8462 13.5742 21.915 13.6874 21.9618C13.8006 22.0087 13.9219 22.0328 14.0444 22.0328H21.8318C21.9543 22.0328 22.0756 22.0087 22.1888 21.9618C22.3019 21.9149 22.4048 21.8462 22.4914 21.7596C22.578 21.673 22.6467 21.5702 22.6936 21.457C22.7405 21.3438 22.7646 21.2225 22.7646 21.1V20.5229C22.7741 19.7302 22.6148 18.9445 22.2971 18.2182Z"
					fill="#FFFFFF"
				/>
				<path
					d="M10.5454 19.6737H7.18399C6.74641 19.6732 6.32689 19.4992 6.01747 19.1897C5.70805 18.8803 5.53399 18.4608 5.53347 18.0232V16.5723L6.11637 17.0912C6.24642 17.2069 6.41709 17.2662 6.59085 17.256C6.7646 17.2458 6.92721 17.1671 7.04288 17.037C7.15856 16.907 7.21784 16.7363 7.20768 16.5625C7.19751 16.3888 7.11874 16.2262 6.98869 16.1105L5.31327 14.6193C5.19312 14.5124 5.03791 14.4534 4.87711 14.4534C4.7163 14.4534 4.56109 14.5124 4.44094 14.6193L2.76563 16.1105C2.63558 16.2262 2.55681 16.3888 2.54665 16.5625C2.54162 16.6486 2.55358 16.7348 2.58186 16.8162C2.61013 16.8976 2.65417 16.9726 2.71144 17.037C2.76872 17.1014 2.83812 17.1539 2.91568 17.1915C2.99324 17.229 3.07744 17.251 3.16348 17.256C3.33723 17.2662 3.50791 17.2069 3.63796 17.0912L4.22097 16.5723V18.0232C4.22191 18.8088 4.53439 19.5619 5.08986 20.1174C5.64533 20.6728 6.39844 20.9853 7.18399 20.9862H10.5454C10.7195 20.9862 10.8864 20.9171 11.0095 20.794C11.1325 20.6709 11.2017 20.504 11.2017 20.33C11.2017 20.1559 11.1325 19.989 11.0095 19.8659C10.8864 19.7429 10.7195 19.6737 10.5454 19.6737Z"
					fill="#FFFFFF"
				/>
				<path
					d="M17.2815 5.66855V7.12483L16.6992 6.60643C16.569 6.49211 16.399 6.4339 16.226 6.44449C16.0531 6.45508 15.8914 6.53363 15.7762 6.66298C15.6609 6.79234 15.6015 6.96202 15.6109 7.13501C15.6202 7.308 15.6976 7.47026 15.8262 7.58642L17.5013 9.07764C17.6215 9.18466 17.7767 9.24382 17.9376 9.24388C18.0985 9.24394 18.2538 9.1849 18.374 9.07798L20.0494 7.58679C20.1795 7.47111 20.2583 7.30851 20.2684 7.13475C20.2786 6.96099 20.2193 6.79031 20.1036 6.66026C19.988 6.53021 19.8254 6.45143 19.6516 6.44127C19.4778 6.4311 19.3072 6.49038 19.1771 6.60605L18.594 7.12483V5.66855C18.5931 4.88307 18.2807 4.13 17.7254 3.57453C17.17 3.01906 16.417 2.70656 15.6315 2.70557H12.2695C12.0955 2.70557 11.9286 2.77471 11.8055 2.89778C11.6824 3.02085 11.6133 3.18777 11.6133 3.36182C11.6133 3.53586 11.6824 3.70278 11.8055 3.82586C11.9286 3.94893 12.0955 4.01807 12.2695 4.01807H15.6313C16.0689 4.01859 16.4883 4.19266 16.7977 4.50208C17.1071 4.81151 17.281 5.23101 17.2815 5.66855Z"
					fill="#FFFFFF"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M8.36909 6.30925C8.2919 6.27599 8.22615 6.22085 8.17994 6.15064C8.13374 6.08043 8.10911 5.99823 8.1091 5.91418C8.10858 5.85411 8.12039 5.79457 8.14382 5.73925C8.16725 5.68393 8.20179 5.63401 8.2453 5.59258C8.27185 5.56727 8.29731 5.5423 8.31636 5.52227C8.45101 5.38047 8.56981 5.22443 8.67066 5.0569C8.93598 4.61418 9.06752 4.10415 9.0494 3.58834C9.03128 3.07253 8.86428 2.57299 8.56855 2.14998C8.27282 1.72698 7.861 1.39859 7.38278 1.20445C6.90455 1.01031 6.38036 0.958708 5.87347 1.05587C5.35688 1.14631 4.87947 1.39011 4.50332 1.75554C4.12716 2.12098 3.86968 2.59115 3.76435 3.10491C3.66699 3.54724 3.68358 4.00705 3.81255 4.44121C3.94152 4.87538 4.17866 5.26967 4.50171 5.58711C4.54557 5.62867 4.58067 5.67857 4.60498 5.73387C4.62929 5.78918 4.64231 5.84879 4.64328 5.9092V5.91137C4.64402 5.99612 4.61974 6.07921 4.57347 6.15022C4.5272 6.22123 4.46101 6.27701 4.38318 6.31056C3.31769 6.7519 2.46801 7.59384 2.01693 8.65525C1.6999 9.38214 1.54088 10.1681 1.55039 10.961V11.5327C1.5504 11.7801 1.64869 12.0174 1.82363 12.1923C1.99857 12.3673 2.23584 12.4655 2.48324 12.4655H10.2708C10.5181 12.4655 10.7554 12.3672 10.9303 12.1923C11.1053 12.0174 11.2036 11.7801 11.2036 11.5327V10.9556C11.2131 10.1629 11.0538 9.37718 10.7362 8.65078C10.2844 7.59028 9.43445 6.74948 8.36909 6.30925Z"
					fill="#7B7B7B"
				/>
				<path
					d="M22.2971 18.2182C21.8453 17.1577 20.9954 16.317 19.9301 15.8767C19.8529 15.8434 19.7872 15.7883 19.7409 15.718C19.6947 15.6478 19.6701 15.5656 19.6701 15.4815C19.6696 15.4215 19.6814 15.3619 19.7048 15.3066C19.7282 15.2513 19.7628 15.2014 19.8062 15.16C19.8329 15.1346 19.8583 15.1097 19.8775 15.0896C20.0122 14.9479 20.131 14.7918 20.2319 14.6242C20.4972 14.1815 20.6288 13.6715 20.6107 13.1557C20.5926 12.6399 20.4256 12.1403 20.1298 11.7173C19.8341 11.2943 19.4222 10.9659 18.944 10.7718C18.4658 10.5777 17.9416 10.5261 17.4347 10.6233C16.9181 10.7137 16.4407 10.9575 16.0646 11.3229C15.6885 11.6883 15.431 12.1584 15.3256 12.6721C15.2282 13.1145 15.2448 13.5743 15.3738 14.0085C15.5028 14.4427 15.7399 14.837 16.063 15.1544C16.1068 15.196 16.1419 15.2458 16.1662 15.3011C16.1905 15.3564 16.2035 15.416 16.2044 15.4764V15.4787C16.2052 15.5634 16.1809 15.6465 16.1347 15.7175C16.0884 15.7885 16.0222 15.8443 15.9444 15.8778C14.8789 16.3192 14.0292 17.1611 13.5781 18.2225C13.2611 18.9494 13.102 19.7354 13.1115 20.5284V21.1C13.1115 21.2225 13.1356 21.3438 13.1825 21.457C13.2294 21.5702 13.2981 21.673 13.3847 21.7596C13.4714 21.8462 13.5742 21.915 13.6874 21.9618C13.8006 22.0087 13.9219 22.0328 14.0444 22.0328H21.8318C21.9543 22.0328 22.0756 22.0087 22.1888 21.9618C22.3019 21.9149 22.4048 21.8462 22.4914 21.7596C22.578 21.673 22.6467 21.5702 22.6936 21.457C22.7405 21.3438 22.7646 21.2225 22.7646 21.1V20.5229C22.7741 19.7302 22.6148 18.9445 22.2971 18.2182Z"
					fill="#7B7B7B"
				/>
				<path
					d="M10.5454 19.6737H7.18399C6.74641 19.6732 6.32689 19.4992 6.01747 19.1897C5.70805 18.8803 5.53399 18.4608 5.53347 18.0232V16.5723L6.11637 17.0912C6.24642 17.2069 6.41709 17.2662 6.59085 17.256C6.7646 17.2458 6.92721 17.1671 7.04288 17.037C7.15856 16.907 7.21784 16.7363 7.20768 16.5625C7.19751 16.3888 7.11874 16.2262 6.98869 16.1105L5.31327 14.6193C5.19312 14.5124 5.03791 14.4534 4.87711 14.4534C4.7163 14.4534 4.56109 14.5124 4.44094 14.6193L2.76563 16.1105C2.63558 16.2262 2.55681 16.3888 2.54665 16.5625C2.54162 16.6486 2.55358 16.7348 2.58186 16.8162C2.61013 16.8976 2.65417 16.9726 2.71144 17.037C2.76872 17.1014 2.83812 17.1539 2.91568 17.1915C2.99324 17.229 3.07744 17.251 3.16348 17.256C3.33723 17.2662 3.50791 17.2069 3.63796 17.0912L4.22097 16.5723V18.0232C4.22191 18.8088 4.53439 19.5619 5.08986 20.1174C5.64533 20.6728 6.39844 20.9853 7.18399 20.9862H10.5454C10.7195 20.9862 10.8864 20.9171 11.0095 20.794C11.1325 20.6709 11.2017 20.504 11.2017 20.33C11.2017 20.1559 11.1325 19.989 11.0095 19.8659C10.8864 19.7429 10.7195 19.6737 10.5454 19.6737Z"
					fill="#7B7B7B"
				/>
				<path
					d="M17.2815 5.66855V7.12483L16.6992 6.60643C16.569 6.49211 16.399 6.4339 16.226 6.44449C16.0531 6.45508 15.8914 6.53363 15.7762 6.66298C15.6609 6.79234 15.6015 6.96202 15.6109 7.13501C15.6202 7.308 15.6976 7.47026 15.8262 7.58642L17.5013 9.07764C17.6215 9.18466 17.7767 9.24382 17.9376 9.24388C18.0985 9.24394 18.2538 9.1849 18.374 9.07798L20.0494 7.58679C20.1795 7.47111 20.2583 7.30851 20.2684 7.13475C20.2786 6.96099 20.2193 6.79031 20.1036 6.66026C19.988 6.53021 19.8254 6.45143 19.6516 6.44127C19.4778 6.4311 19.3072 6.49038 19.1771 6.60605L18.594 7.12483V5.66855C18.5931 4.88307 18.2807 4.13 17.7254 3.57453C17.17 3.01906 16.417 2.70656 15.6315 2.70557H12.2695C12.0955 2.70557 11.9286 2.77471 11.8055 2.89778C11.6824 3.02085 11.6133 3.18777 11.6133 3.36182C11.6133 3.53586 11.6824 3.70278 11.8055 3.82586C11.9286 3.94893 12.0955 4.01807 12.2695 4.01807H15.6313C16.0689 4.01859 16.4883 4.19266 16.7977 4.50208C17.1071 4.81151 17.281 5.23101 17.2815 5.66855Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		text: "users",
		permission: "user",
		to: "/users",
	},

	// Reports
	{
		title: "Reports",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M16 2H8C4.5 2 3 4 3 7V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V7C21 4 19.5 2 16 2ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75ZM18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
					fill="#FFFFFF"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M16 2H8C4.5 2 3 4 3 7V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V7C21 4 19.5 2 16 2ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75ZM18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		text: "reports",
		permission: "reports",
		content: [
			{
				title: "Staf & Drivers Reports",
				to: "/staff-drivers",
				text: "staf_dirvers_reports",
				permission: "staff_drivers_report",
			},
			{
				title: "Zones Report",
				to: "/zones-report",
				text: "zones_report",
				permission: "zones_report",
			},
			{
				title: "Average Service Time",
				to: "/average-service-time",
				text: "average_service_time",
				permission: "average_service_time",
			},
			{
				title: "Payment Report",
				to: "/payment-report",
				text: "payment_method",
				permission: "payment_report",
			},
		],
	},

	// Payment Link
	{
		title: "Payment Link",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="23px"
				height="24px"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<rect
						x="3"
						y="6"
						width="18"
						height="13"
						rx="2"
						stroke="#FFF"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"></rect>{" "}
					<path
						d="M3 10H20.5"
						stroke="#FFF"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"></path>{" "}
					<path
						d="M7 15H9"
						stroke="#FFF"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"></path>{" "}
				</g>
			</svg>
		),
		iconDeactive: (
			<svg
				width="23px"
				height="24px"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
				<g
					id="SVGRepo_tracerCarrier"
					strokeLinecap="round"
					strokeLinejoin="round"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<rect
						x="3"
						y="6"
						width="18"
						height="13"
						rx="2"
						stroke="#7B7B7B"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"></rect>{" "}
					<path
						d="M3 10H20.5"
						stroke="#7B7B7B"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"></path>{" "}
					<path
						d="M7 15H9"
						stroke="#7B7B7B"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"></path>{" "}
				</g>
			</svg>
		),
		to: "/payment-link",
		text: "payment_link",
		permission: "payment_link",
	},
	// Push Notification
	{
		title: "Push Notification",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M19.34 14.49L18.34 12.83C18.13 12.46 17.94 11.76 17.94 11.35V8.82C17.94 6.47 16.56 4.44 14.57 3.49C14.05 2.57 13.09 2 11.99 2C10.9 2 9.92 2.59 9.4 3.52C7.45 4.49 6.1 6.5 6.1 8.82V11.35C6.1 11.76 5.91 12.46 5.7 12.82L4.69 14.49C4.29 15.16 4.2 15.9 4.45 16.58C4.69 17.25 5.26 17.77 6 18.02C7.94 18.68 9.98 19 12.02 19C14.06 19 16.1 18.68 18.04 18.03C18.74 17.8 19.28 17.27 19.54 16.58C19.8 15.89 19.73 15.13 19.34 14.49Z"
					fill="white"
				/>
				<path
					d="M14.83 20.01C14.41 21.17 13.3 22 12 22C11.21 22 10.43 21.68 9.87999 21.11C9.55999 20.81 9.31999 20.41 9.17999 20C9.30999 20.02 9.43999 20.03 9.57999 20.05C9.80999 20.08 10.05 20.11 10.29 20.13C10.86 20.18 11.44 20.21 12.02 20.21C12.59 20.21 13.16 20.18 13.72 20.13C13.93 20.11 14.14 20.1 14.34 20.07C14.5 20.05 14.66 20.03 14.83 20.01Z"
					fill="white"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M19.34 14.49L18.34 12.83C18.13 12.46 17.94 11.76 17.94 11.35V8.82C17.94 6.47 16.56 4.44 14.57 3.49C14.05 2.57 13.09 2 11.99 2C10.9 2 9.92 2.59 9.4 3.52C7.45 4.49 6.1 6.5 6.1 8.82V11.35C6.1 11.76 5.91 12.46 5.7 12.82L4.69 14.49C4.29 15.16 4.2 15.9 4.45 16.58C4.69 17.25 5.26 17.77 6 18.02C7.94 18.68 9.98 19 12.02 19C14.06 19 16.1 18.68 18.04 18.03C18.74 17.8 19.28 17.27 19.54 16.58C19.8 15.89 19.73 15.13 19.34 14.49Z"
					fill="#7B7B7B"
				/>
				<path
					d="M14.83 20.01C14.41 21.17 13.3 22 12 22C11.21 22 10.43 21.68 9.87999 21.11C9.55999 20.81 9.31999 20.41 9.17999 20C9.30999 20.02 9.43999 20.03 9.57999 20.05C9.80999 20.08 10.05 20.11 10.29 20.13C10.86 20.18 11.44 20.21 12.02 20.21C12.59 20.21 13.16 20.18 13.72 20.13C13.93 20.11 14.14 20.1 14.34 20.07C14.5 20.05 14.66 20.03 14.83 20.01Z"
					fill="#7B7B7B"
				/>
			</svg>
		),
		to: "/notification",
		text: "notification",
		permission: "notification",
	},

	// Settings
	{
		title: "Settings",
		classsChange: "mm-collapse",
		iconActive: (
			<svg
				width="24"
				height="25"
				viewBox="0 0 24 25"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12 15.5547C13.6569 15.5547 15 14.2115 15 12.5547C15 10.8978 13.6569 9.55469 12 9.55469C10.3431 9.55469 9 10.8978 9 12.5547C9 14.2115 10.3431 15.5547 12 15.5547Z"
					stroke="#fff"
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M2 13.4361V11.6761C2 10.6361 2.85 9.77609 3.9 9.77609C5.71 9.77609 6.45 8.49609 5.54 6.92609C5.02 6.02609 5.33 4.85609 6.24 4.33609L7.97 3.34609C8.76 2.87609 9.78 3.15609 10.25 3.94609L10.36 4.13609C11.26 5.70609 12.74 5.70609 13.65 4.13609L13.76 3.94609C14.23 3.15609 15.25 2.87609 16.04 3.34609L17.77 4.33609C18.68 4.85609 18.99 6.02609 18.47 6.92609C17.56 8.49609 18.3 9.77609 20.11 9.77609C21.15 9.77609 22.01 10.6261 22.01 11.6761V13.4361C22.01 14.4761 21.16 15.3361 20.11 15.3361C18.3 15.3361 17.56 16.6161 18.47 18.1861C18.99 19.0961 18.68 20.2561 17.77 20.7761L16.04 21.7661C15.25 22.2361 14.23 21.9561 13.76 21.1661L13.65 20.9761C12.75 19.4061 11.27 19.4061 10.36 20.9761L10.25 21.1661C9.78 21.9561 8.76 22.2361 7.97 21.7661L6.24 20.7761C5.33 20.2561 5.02 19.0861 5.54 18.1861C6.45 16.6161 5.71 15.3361 3.9 15.3361C2.85 15.3361 2 14.4761 2 13.4361Z"
					stroke="#fff"
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		iconDeactive: (
			<svg
				width="24"
				height="25"
				viewBox="0 0 24 25"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12 15.5547C13.6569 15.5547 15 14.2115 15 12.5547C15 10.8978 13.6569 9.55469 12 9.55469C10.3431 9.55469 9 10.8978 9 12.5547C9 14.2115 10.3431 15.5547 12 15.5547Z"
					stroke="#000"
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M2 13.4361V11.6761C2 10.6361 2.85 9.77609 3.9 9.77609C5.71 9.77609 6.45 8.49609 5.54 6.92609C5.02 6.02609 5.33 4.85609 6.24 4.33609L7.97 3.34609C8.76 2.87609 9.78 3.15609 10.25 3.94609L10.36 4.13609C11.26 5.70609 12.74 5.70609 13.65 4.13609L13.76 3.94609C14.23 3.15609 15.25 2.87609 16.04 3.34609L17.77 4.33609C18.68 4.85609 18.99 6.02609 18.47 6.92609C17.56 8.49609 18.3 9.77609 20.11 9.77609C21.15 9.77609 22.01 10.6261 22.01 11.6761V13.4361C22.01 14.4761 21.16 15.3361 20.11 15.3361C18.3 15.3361 17.56 16.6161 18.47 18.1861C18.99 19.0961 18.68 20.2561 17.77 20.7761L16.04 21.7661C15.25 22.2361 14.23 21.9561 13.76 21.1661L13.65 20.9761C12.75 19.4061 11.27 19.4061 10.36 20.9761L10.25 21.1661C9.78 21.9561 8.76 22.2361 7.97 21.7661L6.24 20.7761C5.33 20.2561 5.02 19.0861 5.54 18.1861C6.45 16.6161 5.71 15.3361 3.9 15.3361C2.85 15.3361 2 14.4761 2 13.4361Z"
					stroke="#000"
					strokeWidth="1.5"
					strokeMiterlimit="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
		to: "",
		text: "settings",
		permission: "settings",
		content: [
			// Company Logo
			// {
			// 	title: "Company Logo",
			// 	to: "/company-logo",
			// 	text: "company_logo",
			// },
			// Work Shifts
			{
				title: "Work Shifts",
				to: "/work-shifts",
				text: "work_shifts",
				permission: "work_shift",
			},
			// Iban
			{
				title: "Iban",
				to: "/iban",
				text: "iban",
				permission: "iban",
			},
		],
	},
];
